"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTravelDatesModalToTrackableTravelDates = exports.mapSearchControlTravelPeriodToSearchCriteriaTravelPeriod = exports.calculateMinMaxTravelPeriod = exports.mapSearchControlTravelPeriodToFormTravelDates = exports.mapFlexibleTravelPeriodToFormTravelDate = exports.mapExactTravelPeriodToFormTravelDates = exports.mapFlexibleTravelPeriodToIDurationValue = exports.mapExactTravelPeriodToIDurationValue = exports.mapSearchControlExactTravelPeriodToExactTravelPeriodInput = exports.mapTravelDatesStateToExactTravelPeriodInput = exports.mapTravelDatesModelToTravelPeriodCriteria = exports.mergeTravelDatesState = exports.adjustTravelDates = exports.getReturnDate = exports.calculateReturnDate = exports.calculateDateRange = exports.getDurationValuesBySearchType = exports.getDurationSearchPeriod = exports.FLEXIBLE_DURATION_VALUES = exports.EXACT_DURATION_VALUES = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_utils_1 = require("@hotelplan/libs.utils");
const TravelDates_utils_1 = require("./TravelDates.utils");
exports.EXACT_DURATION_VALUES = [
    { duration: [1], type: 'week' },
    { duration: [2], type: 'week' },
    { duration: [1], type: 'night' },
    { duration: [2], type: 'night' },
    { duration: [3], type: 'night' },
    { duration: [4], type: 'night' },
    { duration: [5], type: 'night' },
    { duration: [6], type: 'night' },
    { duration: [7], type: 'night' },
    { duration: [8], type: 'night' },
    { duration: [9], type: 'night' },
    { duration: [10], type: 'night' },
    { duration: [11], type: 'night' },
    { duration: [12], type: 'night' },
    { duration: [13], type: 'night' },
    { duration: [14], type: 'night' },
];
exports.FLEXIBLE_DURATION_VALUES = [
    ...exports.EXACT_DURATION_VALUES,
    { duration: [1, 8], type: 'night' },
    { duration: [1, 3], type: 'night' },
    { duration: [4, 5], type: 'night' },
    { duration: [6, 8], type: 'night' },
    { duration: [7, 10], type: 'night' },
    { duration: [9, 15], type: 'night' },
    { duration: [16, 22], type: 'night' },
];
const DATE_INPUT_FORMAT = 'yyyy-MM-dd';
const DEFAULT_EXACT_DURATION_IN_DAYS = 7;
const getDurationSearchPeriod = (duration) => {
    return duration.duration.length === 2
        ? graphql_types_1.SearchPeriodType.Flexible
        : graphql_types_1.SearchPeriodType.Exact;
};
exports.getDurationSearchPeriod = getDurationSearchPeriod;
const getDurationValuesBySearchType = (searchType, customFlexibleDurationValues) => {
    const flexibleDurationValues = customFlexibleDurationValues
        ? customFlexibleDurationValues
        : exports.FLEXIBLE_DURATION_VALUES;
    return searchType === graphql_types_1.SearchPeriodType.Flexible
        ? flexibleDurationValues
        : exports.EXACT_DURATION_VALUES;
};
exports.getDurationValuesBySearchType = getDurationValuesBySearchType;
const calculateDateRange = (endDate, startDate) => {
    return (0, libs_utils_1.differenceInCalendarDays)(endDate, startDate);
};
exports.calculateDateRange = calculateDateRange;
const calculateReturnDate = (departureDate, durationInDays) => {
    return (0, libs_utils_1.addDays)(departureDate, durationInDays);
};
exports.calculateReturnDate = calculateReturnDate;
const getReturnDate = (departureDate, returnDate, duration) => {
    if (returnDate) {
        return (0, format_1.default)(returnDate, DATE_INPUT_FORMAT);
    }
    if (!departureDate)
        return null;
    if (!duration) {
        return (0, format_1.default)((0, exports.calculateReturnDate)(departureDate, DEFAULT_EXACT_DURATION_IN_DAYS), DATE_INPUT_FORMAT);
    }
    if (duration) {
        const maxDuration = (0, TravelDates_utils_1.getMaxDurationInDays)(duration);
        return (0, format_1.default)((0, exports.calculateReturnDate)(departureDate, maxDuration), DATE_INPUT_FORMAT);
    }
    return null;
};
exports.getReturnDate = getReturnDate;
function adjustTravelDates(travelDatesState) {
    if (!travelDatesState)
        return null;
    const travelDatesResult = (0, cloneDeep_1.default)(travelDatesState);
    const { defaults, searchType } = travelDatesResult;
    const startOfToday = (0, libs_utils_1.getTodaysDate)();
    const departureStartDay = (0, libs_utils_1.startOfDay)(travelDatesResult.departureDate);
    const returnStartDay = travelDatesResult.returnDate
        ? (0, libs_utils_1.startOfDay)(travelDatesResult.returnDate)
        : null;
    const departureInPast = (0, libs_utils_1.isBefore)(departureStartDay, startOfToday) ||
        (0, libs_utils_1.isEqual)(departureStartDay, startOfToday);
    const returnInPast = returnStartDay
        ? (0, libs_utils_1.isBefore)(returnStartDay, startOfToday) ||
            (0, libs_utils_1.isEqual)(returnStartDay, startOfToday)
        : false;
    if (departureInPast && returnInPast) {
        if (defaults && searchType === graphql_types_1.SearchPeriodType.Flexible) {
            travelDatesResult.departureDate = defaults.flexible.departureDate;
            travelDatesResult.returnDate = defaults.flexible.returnDate;
        }
        if (defaults && searchType === graphql_types_1.SearchPeriodType.Exact) {
            travelDatesResult.departureDate = defaults.exact.departureDate;
            travelDatesResult.returnDate = defaults.exact.returnDate;
        }
    }
    else if (departureInPast) {
        // If departure date in the past, set today + 1
        travelDatesResult.departureDate = (0, libs_utils_1.addDays)(startOfToday, 1);
        if (returnStartDay && searchType === graphql_types_1.SearchPeriodType.Flexible) {
            const diffDays = Math.abs((0, libs_utils_1.differenceInCalendarDays)(travelDatesResult.departureDate, returnStartDay));
            const currDuration = travelDatesResult.duration.duration[0];
            if (diffDays < currDuration) {
                travelDatesResult.returnDate = (0, libs_utils_1.addDays)(travelDatesResult.departureDate, currDuration);
            }
        }
    }
    return travelDatesResult;
}
exports.adjustTravelDates = adjustTravelDates;
function mergeTravelDatesState(travelDatesState, globalTravelDates) {
    if (!travelDatesState)
        return null;
    let travelDates = travelDatesState;
    if (globalTravelDates) {
        travelDates = Object.assign(Object.assign({}, globalTravelDates), { defaults: travelDatesState.defaults });
    }
    return adjustTravelDates(travelDates);
}
exports.mergeTravelDatesState = mergeTravelDatesState;
const mapTravelDatesModelToTravelPeriodCriteria = (travelDates) => {
    const searchPeriodType = travelDates
        ? travelDates.searchType
        : graphql_types_1.SearchPeriodType.Exact;
    const returnDate = (0, exports.getReturnDate)(travelDates === null || travelDates === void 0 ? void 0 : travelDates.departureDate, travelDates === null || travelDates === void 0 ? void 0 : travelDates.returnDate, travelDates === null || travelDates === void 0 ? void 0 : travelDates.duration);
    return {
        departureDate: travelDates
            ? (0, format_1.default)(travelDates.departureDate, DATE_INPUT_FORMAT)
            : null,
        returnDate,
        maxDuration: travelDates
            ? (0, TravelDates_utils_1.getMaxDurationInDays)(travelDates.duration)
            : null,
        minDuration: travelDates
            ? (0, TravelDates_utils_1.getMinDurationInDays)(travelDates.duration)
            : null,
        searchPeriodType,
    };
};
exports.mapTravelDatesModelToTravelPeriodCriteria = mapTravelDatesModelToTravelPeriodCriteria;
const mapTravelDatesStateToExactTravelPeriodInput = (travelDates) => {
    const returnDate = (0, exports.getReturnDate)(travelDates === null || travelDates === void 0 ? void 0 : travelDates.departureDate, travelDates === null || travelDates === void 0 ? void 0 : travelDates.returnDate, travelDates === null || travelDates === void 0 ? void 0 : travelDates.duration);
    return {
        departureDate: travelDates
            ? (0, format_1.default)(travelDates.departureDate, DATE_INPUT_FORMAT)
            : '',
        returnDate: returnDate || '',
    };
};
exports.mapTravelDatesStateToExactTravelPeriodInput = mapTravelDatesStateToExactTravelPeriodInput;
const mapSearchControlExactTravelPeriodToExactTravelPeriodInput = (travelPeriod) => {
    return {
        returnDate: (travelPeriod === null || travelPeriod === void 0 ? void 0 : travelPeriod.returnDate) || '',
        departureDate: (travelPeriod === null || travelPeriod === void 0 ? void 0 : travelPeriod.departureDate) || '',
    };
};
exports.mapSearchControlExactTravelPeriodToExactTravelPeriodInput = mapSearchControlExactTravelPeriodToExactTravelPeriodInput;
const mapExactTravelPeriodToIDurationValue = (travelPeriod) => {
    const returnDate = (0, libs_utils_1.parseDateStr)(travelPeriod.returnDate);
    const departureDate = (0, libs_utils_1.parseDateStr)(travelPeriod.departureDate);
    return {
        duration: [(0, exports.calculateDateRange)(returnDate, departureDate)],
        type: 'night',
    };
};
exports.mapExactTravelPeriodToIDurationValue = mapExactTravelPeriodToIDurationValue;
const mapFlexibleTravelPeriodToIDurationValue = (travelPeriod) => {
    return {
        duration: travelPeriod.minDuration === travelPeriod.maxDuration
            ? [travelPeriod.minDuration]
            : [travelPeriod.minDuration, travelPeriod.maxDuration],
        type: 'night',
    };
};
exports.mapFlexibleTravelPeriodToIDurationValue = mapFlexibleTravelPeriodToIDurationValue;
const mapExactTravelPeriodToFormTravelDates = (travelPeriod) => {
    const returnDate = travelPeriod.returnDate
        ? (0, libs_utils_1.parseDateStr)(travelPeriod.returnDate)
        : null;
    const departureDate = (0, libs_utils_1.parseDateStr)(travelPeriod.departureDate);
    const duration = (0, exports.mapExactTravelPeriodToIDurationValue)(travelPeriod);
    const extraDurations = (0, TravelDates_utils_1.containsDurationValue)(duration, exports.FLEXIBLE_DURATION_VALUES)
        ? []
        : [duration];
    return {
        departureDate,
        returnDate,
        duration,
        extraDurations,
        searchType: graphql_types_1.SearchPeriodType.Exact,
    };
};
exports.mapExactTravelPeriodToFormTravelDates = mapExactTravelPeriodToFormTravelDates;
const mapFlexibleTravelPeriodToFormTravelDate = (travelPeriod) => {
    const returnDate = (0, libs_utils_1.parseDateStr)(travelPeriod.returnDate);
    const departureDate = (0, libs_utils_1.parseDateStr)(travelPeriod.departureDate);
    const duration = (0, exports.mapFlexibleTravelPeriodToIDurationValue)(travelPeriod);
    const extraDurations = (0, TravelDates_utils_1.containsDurationValue)(duration, exports.FLEXIBLE_DURATION_VALUES)
        ? []
        : [duration];
    return {
        departureDate,
        returnDate,
        duration,
        extraDurations,
        searchType: graphql_types_1.SearchPeriodType.Flexible,
    };
};
exports.mapFlexibleTravelPeriodToFormTravelDate = mapFlexibleTravelPeriodToFormTravelDate;
const mapSearchControlTravelPeriodToFormTravelDates = (travelPeriodComponent) => {
    const exactTravelDates = (0, exports.mapExactTravelPeriodToFormTravelDates)(travelPeriodComponent.exactPeriod);
    const flexibleTravelDates = (0, exports.mapFlexibleTravelPeriodToFormTravelDate)(travelPeriodComponent.flexiblePeriod);
    if (travelPeriodComponent.type === graphql_types_1.SearchPeriodType.Exact) {
        return Object.assign(Object.assign({}, exactTravelDates), { defaults: { exact: exactTravelDates, flexible: flexibleTravelDates } });
    }
    return Object.assign(Object.assign({}, flexibleTravelDates), { defaults: { exact: exactTravelDates, flexible: flexibleTravelDates } });
};
exports.mapSearchControlTravelPeriodToFormTravelDates = mapSearchControlTravelPeriodToFormTravelDates;
function calculateMinMaxTravelPeriod(travelPeriodComponent) {
    let minDuration = null;
    let maxDuration = null;
    if ((travelPeriodComponent === null || travelPeriodComponent === void 0 ? void 0 : travelPeriodComponent.type) === graphql_types_1.SearchPeriodType.Flexible) {
        minDuration = travelPeriodComponent.flexiblePeriod.minDuration;
        maxDuration = travelPeriodComponent.flexiblePeriod.maxDuration;
    }
    if ((travelPeriodComponent === null || travelPeriodComponent === void 0 ? void 0 : travelPeriodComponent.type) === graphql_types_1.SearchPeriodType.Exact) {
        const { departureDate, returnDate } = travelPeriodComponent.exactPeriod;
        const duration = departureDate && returnDate
            ? (0, exports.calculateDateRange)((0, libs_utils_1.parseDateStr)(returnDate), (0, libs_utils_1.parseDateStr)(departureDate))
            : null;
        minDuration = duration;
        maxDuration = duration;
    }
    return [minDuration, maxDuration];
}
exports.calculateMinMaxTravelPeriod = calculateMinMaxTravelPeriod;
const mapSearchControlTravelPeriodToSearchCriteriaTravelPeriod = (travelPeriodComponent) => {
    const [minDuration, maxDuration] = calculateMinMaxTravelPeriod(travelPeriodComponent);
    const travelPeriod = (travelPeriodComponent === null || travelPeriodComponent === void 0 ? void 0 : travelPeriodComponent.type) === graphql_types_1.SearchPeriodType.Exact
        ? travelPeriodComponent.exactPeriod
        : travelPeriodComponent === null || travelPeriodComponent === void 0 ? void 0 : travelPeriodComponent.flexiblePeriod;
    return {
        minDuration,
        maxDuration,
        departureDate: travelPeriod === null || travelPeriod === void 0 ? void 0 : travelPeriod.departureDate,
        returnDate: travelPeriod === null || travelPeriod === void 0 ? void 0 : travelPeriod.returnDate,
        searchPeriodType: (travelPeriodComponent === null || travelPeriodComponent === void 0 ? void 0 : travelPeriodComponent.type) || graphql_types_1.SearchPeriodType.Flexible,
    };
};
exports.mapSearchControlTravelPeriodToSearchCriteriaTravelPeriod = mapSearchControlTravelPeriodToSearchCriteriaTravelPeriod;
const mapTravelDatesModalToTrackableTravelDates = (state) => {
    var _a;
    return {
        duration: (_a = state.duration) === null || _a === void 0 ? void 0 : _a.duration.join('-'),
        exact: state.searchType === graphql_types_1.SearchPeriodType.Exact,
        from: state.departureDate,
        to: state.returnDate,
    };
};
exports.mapTravelDatesModalToTrackableTravelDates = mapTravelDatesModalToTrackableTravelDates;
//# sourceMappingURL=TravelDates.mappers.js.map